import type { AssertionRenderModel } from "../assertions";

import BooleanCellBadge from "./BooleanCellBadge";

import { BasicTooltip, InfoTooltipContent, type InfoTooltipSection } from "@/components/ui/Tooltip";

interface LLMAssertionCellPreviewProps {
  model: AssertionRenderModel;
}

export default function LLMAssertionCellPreview({ model }: LLMAssertionCellPreviewProps) {
  if (model.assertions.length === 0) {
    return <div className="group/cell relative h-full w-full" aria-hidden="true" />;
  }

  return (
    <div className="group/cell relative flex h-full w-full min-w-0 items-center overflow-hidden">
      <div
        className="grid h-full w-full"
        style={{ gridTemplateColumns: `repeat(${model.assertions.length}, minmax(0,1fr))` }}
      >
        {model.assertions.map(assertion => {
          const sections: InfoTooltipSection[] = [
            {
              key: "assertion",
              title: "Assertion",
              items: [
                {
                  key: "assertion-text",
                  label: "",
                  value: assertion.key,
                  className: "whitespace-pre-wrap text-gray-700",
                },
              ],
            },
          ];

          if (assertion.reasoning) {
            sections.push({
              key: "reasoning",
              title: "Reasoning",
              items: [
                {
                  key: "reasoning-value",
                  label: "",
                  value: assertion.reasoning,
                  className: "whitespace-pre-wrap text-gray-600",
                },
              ],
            });
          }

          if (assertion.citation) {
            sections.push({
              key: "citation",
              title: "Citation",
              items: [
                {
                  key: "citation-value",
                  label: "",
                  value: assertion.citation,
                  className: "whitespace-pre-wrap italic text-gray-500",
                },
              ],
            });
          }

          return (
            <div
              key={assertion.key}
              className="flex h-full min-w-0 items-center justify-center border-r border-border/50 last:border-r-0"
            >
              <BasicTooltip
                content={
                  <InfoTooltipContent sections={sections} className="min-w-[220px] max-w-[340px]" />
                }
                side="top"
                variant="white"
                disabled={!assertion.key}
              >
                <BooleanCellBadge value={assertion.value} />
              </BasicTooltip>
            </div>
          );
        })}
      </div>
    </div>
  );
}
